<div>

  <form #barriersEntryForm="ngForm" novalidate="novalidate">

    <div class="row mt-5 mb-4" *ngIf="currentReport?.LATEST?.RISK && currentReport.LATEST.COMPANY.NAICS.R_BE === false && !currentReport.LATEST.RISK.OPT_BE">
      <div class="col-md-12 text-center">
        Barriers Entry was deemed a non-factor for the company based on Industry Type.
        <p>Should you wish to determine Barriers Entry Risk, please click <a role="button" class="color--blue"
            (click)="currentReport.isLocked ? '' : showHideBarriersEntry()">here</a>.</p>
      </div>
    </div>

    <div class="my-5" *ngIf="currentReport?.LATEST?.RISK && (currentReport.LATEST.COMPANY.NAICS.R_BE || currentReport.LATEST.RISK.OPT_BE)">
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="label">Are there any significant barriers to entry for a competitor to offer similar
            products/service?
          </div>
          <div class="color-secondary-gray font-size-12 font-weight-normal mb-2">(quota liquor license, intellectual
            property,
            copyright/patent, etc.)
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <radio-group-button radioGroupButtonId="risk-be-licenses-type-radio-group" [selectedOption]="currentReport.LATEST.RISK.BE_LICENSES" [btnList]="barrierEntryList"
                [isButton]="true" [(ngModel)]="currentReport.LATEST.RISK.BE_LICENSES" #BE_LICENSES="ngModel"
                name="BE_LICENSES" required [disabled]="currentReport?.isLocked"
                (optionChange)="currentReport.LATEST.RISK.BE_LICENSES = $event; callUpdateAPI('BE_LICENSES')">
              </radio-group-button>
            </div>
          </div>

        </div>
      </div>

      <div class="row" *ngIf="currentReport.LATEST.RISK.BE_LICENSES == 'YES'">
        <div class="col-md-12 mb-2">
          <div class="label">What is the most possible situation:</div>

          <input type="text" id="risk-be-licenses-req" [(ngModel)]="currentReport.LATEST.RISK.BE_LICENSES_REQ" #BE_LICENSES_REQ="ngModel" style="display: none;"
            name="BE_LICENSES_REQ" required [disabled]="currentReport?.isLocked">

          <div class="situation-list" *ngFor="let sl of situationList; let i = index"
            [class.selected]="currentReport.LATEST.RISK.BE_LICENSES_REQ == sl.value"
            (click)="updateSituation(sl)">

            <div *ngIf="sl.title">
              <div [innerHtml]="sl.title"></div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </form>


</div>

<report-footer
  [nextBtnEnable]="(currentReport?.LATEST?.RISK && barriersEntryForm.valid) || currentReport?.isLocked"
  (buttonClicked)="footerButtonClick($event)" [extraBtnText]="'Back to Optional'"
  [extraAvailable]="!currentReport?.isLocked && !currentReport?.LATEST?.COMPANY.NAICS.R_BE && currentReport?.LATEST?.RISK.OPT_BE"
  [skipAvailable]="!currentReport?.isLocked" [skipArrow]="false" [skipBtnText]="'Reset'"
  [pageId]="reportPageConst.BARRIERS_ENRTY" [mobileIcon]="'reset-icon'"></report-footer>
